// extracted by mini-css-extract-plugin
export var wrapper = "BlueModule-module--wrapper--BWfTC";
export var headline = "BlueModule-module--headline--ZjczS";
export var container = "BlueModule-module--container--7oir5";
export var submodule = "BlueModule-module--submodule--OEZvh";
export var subtitleModule = "BlueModule-module--subtitleModule--ZQ0BW";
export var icon = "BlueModule-module--icon--5kcJl";
export var smallIcon = "BlueModule-module--smallIcon--NOGxh";
export var smallerIcon = "BlueModule-module--smallerIcon--YXi6T";
export var subtitle = "BlueModule-module--subtitle--eg2Kx";
export var text = "BlueModule-module--text--GFUwp";